import React, { useContext, useEffect, useState, useRef } from "react";
import PageHeading from "../../Components/PageHeading/PageHeading";
import profileUpdateBtn from "../../Assets/Images/profile-photo-update-icon.png";
import moneyExchangeIcon from "../../Assets/Images/transaction.png";
import "./Account.css";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import axios from "axios";
import { useTimer } from "react-timer-hook";
import EmailVerifyModal from "./EmailVerifyModal";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
import CopyToClipboard from "react-copy-to-clipboard";
import ct from "countries-and-timezones";
import countryToCurrency from "country-to-currency";
import { useCallback } from "react";
import { AddCircleOutline, CloseRounded } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-hot-toast";
// Build a name-to-ISO lookup from countries-and-timezones
const allCountriesObj = ct.getAllCountries();
const countryNameToIso = {};
Object.values(allCountriesObj).forEach((c) => {
  countryNameToIso[c.name] = c.id; // e.g. "India" -> "IN"
});

const COUNTRIES = Object.values(allCountriesObj)
  .map((country) => country.name)
  .sort();

// Get currency code for a country name using countryToCurrency
const getCurrencyForCountry = (countryName) => {
  const iso = countryNameToIso[countryName];
  if (iso && countryToCurrency[iso]) {
    return countryToCurrency[iso];
  }
  return "";
};

const DEFAULT_THEME_COLORS = {
  color1: "#3080AC",
  color2: "#08243B",
  color3: "#FFA500",
};

const Dashboard = () => {
  const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const [openEmailVerify, setOpenEmailVerify] = useState("");
  const [allUserAffiliateCode, setAllUserAffiliateCode] = useState([]);
  const [introducerInput, setIntroducerInput] = useState("");
  const [password, setPassword] = useState("");

  const [emailOtp, setEmailOtp] = useState("");
  const [profileImg, setProfileImg] = useState("");
  const [aiActivition, setAiActivition] = useState(false);

  // Country & Currency state
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [countryEdited, setCountryEdited] = useState(false);
  const [countryLoading, setCountryLoading] = useState(true);

  // Logo upload state
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");
  const logoInputRef = useRef(null);

  // Theme colors state
  const [themeColors, setThemeColors] = useState({ ...DEFAULT_THEME_COLORS });
  const colorInputRefs = {
    color1: useRef(null),
    color2: useRef(null),
    color3: useRef(null),
  };
  const [savedThemeColors, setSavedThemeColors] = useState({});
  const [isThemeDirty, setIsThemeDirty] = useState(false);
  const [themeSaving, setThemeSaving] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, [location]);

  const isPaymentSuccess = location?.state?.success;
  const credits = location?.state?.credits;

  useEffect(() => {
    const paymentAlert = async () => {
      try {
        if (isPaymentSuccess === true) {
          swal({
            title: "Success!",
            text: `You have purchased ${credits} credits successfully!`,
            icon: "success",

            button: "OK",

            className: "modal_class_success",
          });
        }
      } catch (err) {
        console.log("Error from dashboard", err);
      }
    };
    paymentAlert();
  }, [isPaymentSuccess, credits]);

  useEffect(() => {
    if (!AIuser) return;

    setUserName(AIuser?.name || "");
    setUserEmail(AIuser?.email || "");
    setProfileImg(AIuser?.image || "");

    setLogoPreview(AIuser?.logo || "");

    if (AIuser?.colors?.length === 3) {
      const backendColors = {
        color1: AIuser.colors[0] && AIuser.colors[0] !== "undefined" && AIuser.colors[0] !== "null" ? AIuser.colors[0] : DEFAULT_THEME_COLORS.color1,
        color2: AIuser.colors[1] && AIuser.colors[1] !== "undefined" && AIuser.colors[1] !== "null" ? AIuser.colors[1] : DEFAULT_THEME_COLORS.color2,
        color3: AIuser.colors[2] && AIuser.colors[2] !== "undefined" && AIuser.colors[2] !== "null" ? AIuser.colors[2] : DEFAULT_THEME_COLORS.color3,
      };

      setThemeColors(backendColors);
      setSavedThemeColors(backendColors);
    } else {
      setThemeColors(DEFAULT_THEME_COLORS);
      setSavedThemeColors(DEFAULT_THEME_COLORS);
    }
  }, [AIuser]);

  // Detect country by IP on mount (only if not previously edited)
  useEffect(() => {
    const detectCountry = async () => {
      const savedCountry = AIuser?.country;
      const savedCurrency = AIuser?.currency;

      if (savedCountry) {
        setSelectedCountry(savedCountry);
        setSelectedCurrency(
          savedCurrency || getCurrencyForCountry(savedCountry) || "SGD"
        );
        setCountryEdited(true);
        setCountryLoading(false);
        return;
      }

      try {
        const res = await fetch(
          "https://backend.aisuperbot.org/api/v1/location"
        );

        if (!res.ok) throw new Error("Location API failed");

        const json = await res.json();

        const countryName = json?.data?.country || "";

        const matched = COUNTRIES.find(
          (c) => c.toLowerCase() === countryName.toLowerCase()
        );

        const finalCountry = matched || countryName || "Singapore";
        const finalCurrency =
          getCurrencyForCountry(finalCountry) || "SGD";

        setSelectedCountry(finalCountry);
        setSelectedCurrency(finalCurrency);

      } catch (err) {
        console.log("Location detection failed:", err);

        setSelectedCountry("Singapore");
        setSelectedCurrency("SGD");
      } finally {
        setCountryLoading(false);
      }
    };
    detectCountry();

  }, [AIuser]);

  const handleCountryChange = async (e) => {
    const country = e.target.value;
    setSelectedCountry(country);
    const currency = getCurrencyForCountry(country);
    const countryChangeFormData = new FormData();
    countryChangeFormData.append("country", country);
    countryChangeFormData.append("currency", currency);

    await axios.put("https://backend.whalesai.com/api/dashboard/user_signup-signin/user/update", countryChangeFormData,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("aiUser")}`,
        },
      }
    )
      .then((res) => {
        if (res.status === 200) {
          setSelectedCurrency(currency);
          setCountryEdited(true);
          swal({
            title: "Successful",
            text: "Country and Currency updated successfully",
            icon: "success",
            button: "OK",
            className: "modal_class_success",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    const logoFormData = new FormData();
    logoFormData.append("user-logo", file);
    await axios.put("https://backend.whalesai.com/api/dashboard/user_signup-signin/user/update", logoFormData,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("aiUser")}`,
        },
      }
    )
      .then(() => {
        swal({
          title: "Successful",
          text: "Logo updated successfully",
          icon: "success",
          button: "OK",
          className: "modal_class_success",
        });
      })
      .catch((err) => {
        console.log(err);
      });
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
        // localStorage.setItem("dashboard_logo", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleThemeColorChange = (colorKey, value) => {
    const updated = {
      ...themeColors,
      [colorKey]: value,
    };

    setThemeColors(updated);

    const isDirty =
      updated.color1 !== savedThemeColors.color1 ||
      updated.color2 !== savedThemeColors.color2 ||
      updated.color3 !== savedThemeColors.color3;

    setIsThemeDirty(isDirty);
  };

  const handleUpdateThemeColors = async () => {
    if (!isThemeDirty) return;

    setThemeSaving(true);

    const themeColorFormData = new FormData();
    themeColorFormData.append("color1", themeColors.color1 && themeColors.color1 !== "undefined" ? themeColors.color1 : DEFAULT_THEME_COLORS.color1);
    themeColorFormData.append("color2", themeColors.color2 && themeColors.color2 !== "undefined" ? themeColors.color2 : DEFAULT_THEME_COLORS.color2);
    themeColorFormData.append("color3", themeColors.color3 && themeColors.color3 !== "undefined" ? themeColors.color3 : DEFAULT_THEME_COLORS.color3);

    try {
      const res = await axios.put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/user/update",
        themeColorFormData,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("aiUser")}`,
          },
        }
      );

      if (res.status === 200) {
        const saved = { ...themeColors };

        setSavedThemeColors(saved);
        setIsThemeDirty(false);

        swal({
          title: "Successful",
          text: "Theme updated successfully",
          icon: "success",
          button: "OK",
          className: "modal_class_success",
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setThemeSaving(false);
    }
  };

  // Profile update fn
  const [previewProfile, setPreviewProfile] = useState("");
  const [uploadedImg, setUploadedImg] = useState("");

  const selectProfile = (event) => {
    if (event.target.files[0]) {
      setUploadedImg(event.target.files[0]);
      setPreviewProfile(URL.createObjectURL(event.target.files[0]));
    } else {
      setUploadedImg("");
      setPreviewProfile("");
    }
  };

  useEffect(() => {
    updateProfile();
  }, [uploadedImg]);

  //image update
  const updateProfile = async () => {
    const ImageFormData = new FormData();
    ImageFormData.append("user-image", uploadedImg);

    if (uploadedImg) {
      await axios
        .put(
          "https://backend.whalesai.com/api/dashboard/user_signup-signin/user/update",
          ImageFormData,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("aiUser")}`,
            },
          }
        )
        .then((res) => {
          // console.log("update");
          if (res.status === 200) {
            swal({
              title: "Successful",
              text: "Profile updated successfully",
              icon: "success",
              button: "OK",
              className: "modal_class_success",
            });
            setUserRefetch(!userRefetch);
          }
        })
        .catch((error) => console.log(error));
    }
  };

  const updateUserName = async () => {
    const fullNameFormData = new FormData();
    fullNameFormData.append("name", userName);

    if (userName) {
      await axios
        .put(
          "https://backend.whalesai.com/api/dashboard/user_signup-signin/user/update",
          fullNameFormData,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("aiUser")}`,
            },
          }
        )
        .then((res) => {
          // console.log("update");
          if (res.status === 200) {
            swal({
              title: "Successful",
              text: "Name updated successfully",
              icon: "success",
              button: "OK",
              className: "modal_class_success",
            });
            setUserRefetch(!userRefetch);
          }
        });
    }
  };

  // Timer here
  const time = new Date();
  time.setSeconds(time.getSeconds() + 180);

  const { seconds, minutes, resume, restart } = useTimer({
    time,
    onExpire: () => console.warn("onExpire called"),
  });

  const restarting = (sec) => {
    const time = new Date();
    time.setSeconds(time.getSeconds() + sec);
    restart(time);
  };
  // Timer ends

  const verifyEmail = async () => {
    if (userEmail.length > 0 && userEmail.includes("@" && ".")) {
      await axios
        .post(
          "https://backend.whalesai.com/api/dashboard/user_signup-signin/email",
          {
            email: userEmail,
          }
        )
        .then((res) => {
          if (res.status === 200) {
            restarting(180);
            swal({
              text: res.data.message,
              icon: "success",
              button: "OK!",
              className: "modal_class_success",
            });
            setEmailOtp(res.data.otp);
          }
          setOpenEmailVerify(true);
        })
        .catch((err) => {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = `<p class='text-break text-white fs-5'>${err.response.data.message}</p>`;

          Swal.fire({
            html: wrapper,
            icon: "warning",
            customClass: "modal_class_success",
          });
        })
        .finally(() => {
          // setLoading(false);
        });
    } else {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = `<p class='text-break text-white fs-5'>Please enter a valid email address</p>`;

      Swal.fire({
        html: wrapper,
        icon: "warning",
        customClass: "modal_class_success",
      });
    }
  };

  const creditTolcalString = AIuser?.credits
    ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
    : "0";

  let content = (
    <>
      <button className="credits-button">CREDITS : {creditTolcalString}</button>
      <button
        className="buy-credits-button"
        onClick={() => navigate("/purchase")}
      >
        BUY CREDITS
      </button>
      <Tooltip placement="top" title="View your purchase history">
        <button
          // onClick={() => navigate("/transaction")}
          className="money-exchange-button"
          onClick={() => navigate("/purchase-history")}
        >
          <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
        </button>
      </Tooltip>
    </>
  );

  const onCopy = useCallback(() => {
    // setCopied(true);

    // alert("Copied");
    Swal.fire({
      icon: "success",
      // title: 'Copied!',
      text: "Copied to your clipboard.",
      timer: 2000,
      showConfirmButton: false,
      background: "#011225",
      color: "white",
    });
  }, []);
  const [gotRefCode, setGotRefCode] = useState(false);

  useEffect(() => {
    const getAllUsers = async () => {
      const response = await axios.get(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/"
      );
      setAllUserAffiliateCode(response?.data?.result);
    };
    getAllUsers();
  }, []);

  const ownRefcode = () => {
    return swal({
      title: "Attention",
      text: "You can’t use your own code.",
      icon: "warning",
      button: "OK",
      dangerMode: true,
      className: "modal_class_success",
    });
  };

  const othersRefCodes = allUserAffiliateCode?.filter(
    (i) => i?.myReferralCode !== AIuser?.myReferralCode
  );

  const handleAffiliateCode = (e) => {
    const refCode = othersRefCodes.find(
      (i) => i?.myReferralCode === e.target.value
    );
    if (refCode?.myReferralCode === e.target.value) {
      setGotRefCode(true);
      setIntroducerInput(e.target.value.trim()?.toUpperCase());
    } else if (e.target.value === AIuser?.myReferralCode) {
      ownRefcode();
    } else {
      setGotRefCode(false);
    }
  };

  const handleAddIntroducerCode = async () => {
    if (introducerInput == "") {
      toast.error("Please enter your introducer code");
    } else {
      const introducerFormData = new FormData();
      introducerFormData.append("introducer", introducerInput.trim());
      await axios
        .put(
          "https://backend.whalesai.com/api/dashboard/user_signup-signin/user/update",
          introducerFormData,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("aiUser")}`,
            },
          }
        )
        .then((res) => {
          // console.log("update");
          if (res.status === 200) {
            setUserRefetch(!userRefetch);
            toast.success("Your introducer code has been added successfully!");
          }
        });
    }
  };

  const onSubmitPassword = (e) => {
    if (password.trim() === "") {
      toast.error("Please enter password to change!");
    } else {
      e.preventDefault();
      axios
        .post(
          "https://backend.whalesai.com/api/dashboard/user_signup-signin/reset-password",
          { newPassword: password },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("aiUser")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            swal({
              title: "Success",
              text: `${res.data.message}`,
              icon: "success",
              button: "OK!",
              className: "modal_class_success",
            });
            setPassword("");
          }
        })
        .catch((err) => {
          swal({
            title: "Attention",
            text: `${err.response.data.message}`,
            icon: "warning",
            button: "OK!",
            className: "modal_class_success",
          });
        });
    }
  };

  // Get 5% discount at whalesai.com when you use my code. https://whalesai.com/${AIuser?.myReferralCode}

  const handleShareCopy = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(`Get 5% off your first credit purchase at WhalesAI! Use my code ${AIuser?.myReferralCode} or link: https://whalesai.com/${AIuser?.myReferralCode}`).then(() => {
      Swal.fire({
        icon: "success",
        // title: 'Copied!',
        text: "Copied to your clipboard.",
        timer: 2000,
        showConfirmButton: false,
        background: "#011225",
        color: "white",
      });
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  return (
    <div>
      <PageHeading title={"DASHBOARD"} />
      <div className="container account-container pb-5">
        <div className="d-flex justify-content-center">
        </div>

        <div className="d-flex d-md-none align-items-center justify-content-center pb-3">
          {content}
        </div>

        {
          AIuser?.affiliateCode?.extraCredit && AIuser?.affiliateCode?.extraCredit > 0 && <p className="text-center fs-6 text-white d-block d-md-none px-3">You have received an additional {AIuser?.affiliateCode?.extraCredit} credits through your affiliate code as part of our affiliate agreement.</p>
        }

        <div className="profile-header d-flex flex-column flex-lg-row align-items-center justify-content-between gap-2">
          <div className="d-flex align-items-center justify-content-center gap-2">
            <div className="avatar-portion d-flex align-items-center gap-2">
              <div className="avatar-container">
                <img
                  style={{ borderRadius: "8px" }}
                  className="avatar"
                  src={
                    previewProfile
                      ? previewProfile
                      : profileImg || "https://backend.whalesai.com/public/assets/user.png"
                  }
                  alt="profileImg"
                />

                <label className="profile-update-button" for="profile-img">
                  <img src={profileUpdateBtn} alt="profileUpdateBtn" />
                </label>
                <input
                  onChange={(e) => selectProfile(e)}
                  className="w-100 d-none"
                  type="file"
                  accept="image/*"
                  name="image"
                  id="profile-img"
                />
              </div>

            </div>
            <div className="d-none d-md-flex align-items-start">{content}</div>
            <div className="d-flex align-items-center">
              <Tooltip
                placement="top"
                title="Schedule Text, Image or Video for your social media for the next
                12 months."
              />
            </div>
          </div>
          <div className="d-block d-md-none w-100">
            {AIuser?.affiliateCode?.code && <p className="text-center fs-6 text-white mt-3">Affiliate code applied during sign-up: <span className="text-white fs-6">{AIuser?.affiliateCode?.code}</span></p>}
          </div>

          <div className="my-4 d-flex align-items-center justify-content-center">
            <button
              className="consultant-button text-center text-white fs-6 py-2 px-4  rounded"
              style={{ background: "#bb2d3b", border: "0" }}
              onClick={() =>
                aiActivition
                  ? setAiActivition(true)
                  : navigate("/social-media-consultant")
              }
            >
              {!aiActivition ? (
                <div
                  className={
                    "d-flex flex-column justify-content-center align-items-center"
                  }
                >
                  <span>Your Social Media Consultant is ready to help you plan your social media marketing.</span>
                  <span>Click here to discuss your strategy.</span>
                </div>
              ) : (
                `Our Social Media Consultant is now activated and ready to assist you.`
              )}
            </button>
          </div>
        </div>

        {
          AIuser?.affiliateCode?.extraCredit && AIuser?.affiliateCode?.extraCredit > 0 && <p className="text-center fs-6 text-white d-none d-md-block mb-0">You have received an additional {AIuser?.affiliateCode?.extraCredit} credits through your affiliate code as part of our affiliate agreement.</p>
        }
        <div className="d-none d-md-block">
          {AIuser?.affiliateCode?.code && <p className="text-center fs-6 text-white mt-3">Affiliate code applied during sign-up: <span className="text-white fs-6">{AIuser?.affiliateCode?.code}</span></p>}
        </div>

        {AIuser?.introduce && (
          <div className="mt-3 d-flex align-items-center">
            <p
              className="mb-0  me-2"
              style={{
                fontSize: "18px",
                color: "#bbbaba",
              }}
            >
              Your Introducer Code is
            </p>
            <input
              value={
                AIuser?.introducer === "false"
                  ? AIuser?.introduce
                  : AIuser?.introducer
              }
              onChange={handleAffiliateCode}
              // disabled={AIuser?.introducer !== "false"}
              className="introducer-code-input"
              style={{
                backgroundColor: "#d9d9d9",
                textTransform: "uppercase",
                // borderRadius: "5px",
              }}
            />
            <p
              className="dashboard-add-icon mb-0"
              // disabled={true}
              style={{
                opacity: !gotRefCode || AIuser.introducer !== "false" ? 0.5 : 1,
                display: AIuser.introducer !== "false" ? "none" : "block",
                pointerEvents:
                  !gotRefCode || AIuser.introducer !== "false"
                    ? "none"
                    : "auto",
              }}
              onClick={handleAddIntroducerCode}
            >
              {!gotRefCode ? (
                <CloseRounded className="text-danger" style={{}} />
              ) : (
                <AddCircleOutline className="text-success" style={{}} />
              )}
            </p>
          </div>
        )}

        <div className="fields-container">
          <div className="input-container mb-4">
            <label>Full Name</label>
            <div className="position-relative">
              <input
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Full Name"
                className="w-100"
                type="text"
              />

              <button
                disabled={AIuser?.name === userName}
                onClick={updateUserName}
                className="verified-button width-control"
              >
                {/* {AIuser.name === userName ? "UPDATED" : "UPDATE"} */}
                <EditIcon />
              </button>
            </div>
          </div>
          <div className="input-container mb-4">
            <label>Email</label>
            <div className="position-relative">
              <input
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                placeholder="abc@gmail.com"
                className="w-100"
                type="text"
              />

              <button
                disabled={AIuser?.email === userEmail}
                onClick={verifyEmail}
                className="verified-button width-control"
              >
                {AIuser?.email === userEmail ? "VERIFIED" : "VERIFY"}
                {/* <EditIcon/> */}
              </button>
              <button
                disabled={AIuser?.email === userEmail}
                onClick={verifyEmail}
                className="verified-button width-control"
              >
                {AIuser?.email === userEmail ? "VERIFIED" : "VERIFY"}
                {/* <EditIcon/> */}
              </button>
              {/* <button className="verified-button">VERIFIED</button> */}
            </div>
          </div>

          {/* Country Field */}
          <div className="input-container mb-4">
            <label>Country</label>
            <div className="position-relative">
              <select
                value={selectedCountry}
                onChange={handleCountryChange}
                className="w-100 dashboard-select"
              >
                <option value="">Select Country</option>

                {COUNTRIES.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
              {!countryLoading && !countryEdited && (
                <span className="auto-detected-badge">Auto-detected</span>
              )}
            </div>
          </div>

          {/* Currency Field (read-only, driven by country) */}
          <div className="input-container mb-4">
            <label>Currency</label>
            <div className="position-relative">
              <input
                value={selectedCurrency}
                disabled
                className="w-100"
                type="text"
                id="dashboard-currency-input"
              />
            </div>
          </div>

          <div className="input-container mb-4">
            <label>Password</label>
            <div className="position-relative">
              <input
                required
                placeholder="*********"
                className="w-100"
                type="text"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="submit"
                disabled={!password}
                className="verified-button"
                onClick={onSubmitPassword}
              >
                CHANGE PASSWORD
                {/* <EditIcon/> */}
              </button>
            </div>
          </div>
          {/* ===== Assets for Content Creation ===== */}
          <div className="assets-section mt-2 mb-4">
            <h5 className="assets-section-title">Assets for Content Creation</h5>

            {/* Logo Upload */}
            <div className="asset-card mb-4">
              <label className="asset-card-label">Logo</label>
              <div className="logo-upload-area">
                {logoPreview ? (
                  <div className="logo-preview-container">
                    <img
                      src={logoPreview}
                      alt="Uploaded Logo"
                      className="logo-preview-img"
                    />
                    <div className="logo-actions">
                      <button
                        className="logo-action-btn logo-change-btn"
                        onClick={() => logoInputRef.current?.click()}
                      >
                        Change
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    className="logo-dropzone"
                    onClick={() => logoInputRef.current?.click()}
                  >
                    <AddCircleOutline style={{ fontSize: 36, color: "#3080AC" }} />
                    <p className="logo-dropzone-text">Click to upload logo</p>
                    <p className="logo-dropzone-hint">PNG, JPG, SVG (max 2MB)</p>
                  </div>
                )}
                <input
                  ref={logoInputRef}
                  type="file"
                  accept="image/png,image/jpeg,image/svg+xml"
                  onChange={handleLogoUpload}
                  className="d-none"
                  id="logo-upload-input"
                />
              </div>
            </div>

            {/* Theme Colors */}
            <div className="asset-card">
              <label className="asset-card-label">Theme</label>

              <div className="theme-colors-grid">
                {["color1", "color2", "color3"].map((key, idx) => (
                  <div className="theme-color-item" key={key}>
                    <span className="theme-color-label">Color {idx + 1}</span>

                    <div className="theme-color-picker-row">
                      <div className="theme-color-swatch"
                        style={{ backgroundColor: themeColors[key] }}
                        onClick={() => colorInputRefs[key].current?.click()}
                      />

                      <input
                        ref={colorInputRefs[key]}
                        type="color"
                        value={themeColors[key]}
                        onChange={(e) =>
                          handleThemeColorChange(key, e.target.value)
                        }
                        className="theme-color-native-input"
                        id={`theme-color-${idx + 1}`}
                      />

                      <input
                        type="text"
                        value={themeColors[key]?.toUpperCase()}
                        onChange={(e) => {
                          let v = e.target.value;
                          if (/^#[0-9A-Fa-f]{0,6}$/.test(v)) {
                            handleThemeColorChange(key, v);
                          }
                        }}
                        className="theme-color-hex-input"
                        maxLength={7}
                        placeholder="#000000"
                      />
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex align-items-center justify-content-between mt-3">

                {/* Status Text */}
                <span
                  style={{
                    fontSize: "14px",
                    color: isThemeDirty ? "#ffb020" : "#4ade80",
                    fontWeight: 500,
                  }}
                >
                  {isThemeDirty ? "Unsaved changes" : "All changes saved"}
                </span>

                {/* Save Button */}
                <button
                  className="btn btn-primary"
                  onClick={handleUpdateThemeColors}
                  disabled={!isThemeDirty || themeSaving}
                  style={{
                    opacity: !isThemeDirty ? 0.5 : 1,
                    cursor: !isThemeDirty ? "not-allowed" : "pointer",
                  }}
                >
                  {themeSaving ? "Saving..." : "Update Theme"}
                </button>
              </div>
            </div>
          </div>

          <Link to="/earnings" id="affiliate">
            <button className="your-earnings-button bg-success text-light mb-3">
              YOUR EARNINGS
            </button>
          </Link>
          <div className="input-container mb-4" >
            <label>Your Affiliate Code / Member ID</label>
            <div className="position-relative">
              <input
                value={AIuser?.myReferralCode}
                disabled
                className="w-100"
                type="text"
              />
              <CopyToClipboard text={AIuser?.myReferralCode} onCopy={onCopy}>
                <button className="verified-button">COPY</button>
              </CopyToClipboard>
            </div>
          </div>
          <div className="input-container mb-4">
            <label>Your Affiliate Link</label>
            <div className="position-relative">
              <input
                value={`${window.origin}/${AIuser?.myReferralCode}`}
                disabled
                className="w-100"
                type="text"
              />
              <CopyToClipboard
                text={`${window.origin}/${AIuser?.myReferralCode}`}
                onCopy={onCopy}
              >
                <button className="verified-button">COPY</button>
              </CopyToClipboard>
            </div>
          </div>

          {/* <div className="mb-2 text-light">
            <div>
              <label className="">Share Affiliate Link</label>
              <div className="d-flex gap-2 mt-1">
                <TwitterShareButton
                  url={window.location.origin + "/" + AIuser?.myReferralCode}
                  title={`Get 5% discount at whalesai.com when you use my code.`}
                >
                  <TwitterIcon size={40} round={true} />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={window.location.origin + "/" + AIuser?.myReferralCode}
                  summary={`Get 5% discount at whalesai.com when you use my code.`}
                  title={`Get 5% discount at whalesai.com when you use my code.`}
                >
                  <LinkedinIcon size={40} round={true} />
                </LinkedinShareButton>
                <WhatsappShareButton
                  url={window.location.origin + "/" + AIuser?.myReferralCode}
                  title={`Get 5% discount at whalesai.com when you use my code.`}
                >
                  <WhatsappIcon size={40} round={true} />
                </WhatsappShareButton>
                <FacebookShareButton
                  url={window.location.origin + "/" + AIuser?.myReferralCode}
                  quote="Get 5% discount at whalesai.com when you use my code."
                >
                  <FacebookIcon size={40} round={true} />
                </FacebookShareButton>
              </div>
            </div>
          </div> */}
          <p className="text-start text-light">
            {/* Share your affiliate code to earn 5% of our sales which comes from
            you. Your friend enjoy another 5% discount too. */}
            Give 5%, Earn 5% Share your link to give friends 5% off their first order. 
            You’ll earn 5% commission on their first purchase and all future credit purchases.
          </p>

          <div className="d-flex justify-content-between align-items-center">
            <p className="text-start text-light mt-3">
              {/* Get 5% discount at whalesai.com when you use my code.
              https://whalesai.com/{AIuser?.myReferralCode} */}


              Get 5% off your first credit purchase at WhalesAI! Use my code {AIuser?.myReferralCode} or link: https://whalesai.com/{AIuser?.myReferralCode}
            </p>

            <button className="btn btn-sm py-1"
              style={{ backgroundColor: '#3080AC', color: 'white' }}
              onClick={handleShareCopy}
            >COPY</button>
          </div>
        </div>
      </div>

      <EmailVerifyModal
        userEmail={userEmail}
        verifyEmail={verifyEmail}
        minutes={minutes}
        seconds={seconds}
        openEmailVerify={openEmailVerify}
        setOpenEmailVerify={setOpenEmailVerify}
        emailOtp={emailOtp}
      />
    </div>
  );
};

export default Dashboard;
